<button [type]="type" [class]="'btn-' + color + ' ' + size" [disabled]="disabled" (click)="click.emit($event)"> {{ text }} </button>